module.exports = __webpack_public_path__ + "img/shengchanliucheng.6092650e.png";